import React from 'react';
import * as styles from './aiEngineerFellowship.module.scss';

const Pillars = ({ pillars }) => {
  return (
    <section id="pillars">
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <span className={styles.eyebrow}>The Structure</span>
          <h2>Built On Four Pillars</h2>
          <p>
            The program follows the AI Engineering Skills Map published by DeepLearning.AI — with
            an FDE (Forward-Deployed) layer that most courses skip.
          </p>
        </div>
        <div className={styles.pillars}>
          {pillars.map((pillar) => (
            <div className={styles.pillar} key={pillar.h}>
              <div className={styles.k}>{pillar.k}</div>
              <h4>{pillar.h}</h4>
              <p>{pillar.p}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pillars;
